import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import PlanDetailsCard from "components/Plan/PlanDetailsCard.jsx";

import {
  getUserPlan,
  getUserRecommendations
} from "../../services/planDataProvider";
import { getUserPlanDetails } from "../../services/advisorUsers.js";

import { dayjs } from "utils/time.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

class Plan extends React.Component {
  state = {
    value: 0,
    userplans: [],
    recommendations: [],
    selectedRecommendationId: null,
    selectedRecommendationData: null,
    planDetails: null
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    getUserPlan(this.props.axios).then(data => {
      this.setState({ userplans: data.results });
    });

    getUserRecommendations(this.props.axios).then(data => {
      this.setState({ recommendations: data.results }, () => {
        // Auto-select the latest active plan by default
        const recommendations = data.results || [];
        const now = new Date();

        // Find the latest active plan (end_time in the future and active = true)
        const activePlans = recommendations.filter(r => {
          const endDate = new Date(r.end_time);
          return endDate > now && r.active;
        });

        if (activePlans.length > 0) {
          // Sort by end_time descending to get the latest
          const latestActive = activePlans.sort(
            (a, b) => new Date(b.end_time) - new Date(a.end_time)
          )[0];
          this.handleRecommendationChange(latestActive.id);
        }
      });
    });
  }

  handleClick = (name, idx) => e => {
    console.log(name, idx, e);
  };

  renderPlan(planData) {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    if (planData.plan === undefined) {
      return null;
    }
    return (
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: 8,
          overflow: "hidden",
          boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
          marginBottom: 20
        }}
      >
        <div
          style={{ backgroundColor: "#3f51b5", color: "white", padding: 16 }}
        >
          <h4 style={{ margin: 0 }}>{planData.plan.name}</h4>
          <p style={{ margin: 0, opacity: 0.9 }}>{`Available sessions ${
            planData.available_sessions
          }/${planData.total_sessions}`}</p>
        </div>
        <div style={{ padding: 16, backgroundColor: "white" }}>
          <Table
            tableHeaderColor="primary"
            tableData={[
              [
                "Plan start day",
                dayjs(planData.start_time, "YYYY-MM-DDTh:mm:ssZ").format(
                  "MMMM Do YYYY"
                )
              ],
              [
                "Plan expiry day",
                dayjs(planData.end_time, "YYYY-MM-DDTh:mm:ssZ").format(
                  "MMMM Do YYYY"
                )
              ],
              [
                "Avialable sessions",
                `${planData.available_sessions} of ${planData.total_sessions}`
              ],
              [
                "Avialable session time",
                `${planData.avialable_sessions_time} of ${
                  planData.total_sessions_time
                }`
              ]
            ]}
          />
        </div>
        <div
          style={{
            padding: 16,
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#fafafa"
          }}
        >
          <Button
            color="primary"
            onClick={this.handleClick("details", planData.plan.id)}
          >
            See Details
          </Button>
          <Button
            color="primary"
            onClick={this.handleClick("cancel", planData.plan.id)}
          >
            Change Plan
          </Button>
        </div>
      </div>
    );
  }

  renderAdvices(advices) {
    // const { classes } = this.props;
    // console.log("advices", advices);
    return advices.map(advice => {
      return advice.details.length > 0 && this.renderAdvice(advice);
    });
  }

  renderAdvice(advice) {
    // const { classes } = this.props;
    return (
      <div style={{ marginBottom: 12 }}>
        <h6 style={{ marginBottom: 8 }}>{advice.name}</h6>
        <Table
          tableData={advice.details.map(adviceDetail => {
            return [adviceDetail.name, adviceDetail.description];
          })}
        />
      </div>
    );
  }

  renderPlanDetails() {
    const { planDetails, selectedRecommendationData } = this.state;
    
    return <PlanDetailsCard recommendationData={selectedRecommendationData} planDetails={planDetails} />;
  }

  renderRecommendation(recommData) {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    if (recommData.recommendation_type === undefined) {
      return null;
    }
    let detailsString = recommData.details && recommData.details.details;
    if (typeof detailsString === "object") {
      detailsString = "";
    }
    return (
      <div>
        {this.renderPlanDetails()}
        {this.renderAdvices(recommData.health_advices)}
      </div>
    );
  }

  renderUserPlans() {
    let userPlans = this.state.userplans;
    return (
      <GridContainer>
        {userPlans.map((planData, idx) => {
          return (
            <GridItem xs={12} sm={12} md={12} key={`session-${idx}`}>
              {this.renderPlan(planData)}
            </GridItem>
          );
        })}
      </GridContainer>
    );
  }

  handleRecommendationChange = async value => {
    const sel = (this.state.recommendations || []).find(r => r.id === value);
    this.setState({
      selectedRecommendationId: value,
      selectedRecommendationData: sel || null,
      planDetails: null
    });

    try {
      let userId = this.props.user && this.props.user.user_id;
      if (userId && value) {
        const details = await getUserPlanDetails(
          this.props.axios,
          userId,
          value
        );
        this.setState({ planDetails: details });
      }
    } catch (err) {
      // silently ignore fetch errors for now
    }
  };

  renderPlanSelector() {
    const { recommendations = [], selectedRecommendationId } = this.state;
    if (!recommendations || recommendations.length === 0) {
      return null;
    }
    const now = new Date();
    const planOptions = recommendations.map(r => {
      const endDate = new Date(r.end_time);
      const isPast = endDate < now;
      return {
        value: r.id,
        text: `${r.recommendation_type} (${r.start_time} to ${r.end_time})${
          isPast ? " - PAST" : ""
        }`
      };
    });
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomSelect
            labelText={"Select plan"}
            items={planOptions}
            value={selectedRecommendationId}
            onChange={this.handleRecommendationChange}
          />
        </GridItem>
      </GridContainer>
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    return (
      <div>
        {this.renderUserPlans()}
        {this.renderPlanSelector()}
        {this.state.selectedRecommendationId
          ? (() => {
              const sel = (this.state.recommendations || []).find(
                r => r.id === this.state.selectedRecommendationId
              );
              return sel ? (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    {this.renderRecommendation(sel)}
                  </GridItem>
                </GridContainer>
              ) : null;
            })()
          : null}
      </div>
    );
  }
}

Plan.propTypes = {
  classes: PropTypes.object.isRequired,
  axios: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Plan);
